import { REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED, GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED } from '../actions/actionTypes'

const planConfigByStepReducer = (DataPlanConfigByStep = [], actions) => {
    switch (actions.type) {
        case GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED:
            if(Object.keys(actions.DataPlanConfigByStep).length > 0)
            {
                return {...DataPlanConfigByStep,DataPlanConfigByStep: actions.DataPlanConfigByStep};
            }
            else
            {
                return {...DataPlanConfigByStep,DataPlanConfigByStep: []};
            }
        case REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED:
            return {...DataPlanConfigByStep,DataPlanConfigByStep: []};
        default:
            return DataPlanConfigByStep;
    }
}

export default planConfigByStepReducer;